import { Component, inject } from "@angular/core";

import { JslibModule } from "@bitwarden/angular/jslib.module";
import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import { PlatformUtilsService } from "@bitwarden/common/platform/abstractions/platform-utils.service";
import { LinkModule, PopoverModule } from "@bitwarden/components";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "vault-permit-cipher-details-popover",
  templateUrl: "./permit-cipher-details-popover.component.html",
  imports: [PopoverModule, JslibModule, LinkModule],
})
export class PermitCipherDetailsPopoverComponent {
  private platformUtilService = inject(PlatformUtilsService);

  constructor(private i18nService: I18nService) {}

  openLearnMore(e: Event) {
    e.preventDefault();
    this.platformUtilService.launchUri(this.i18nService.t("getHelpUrl"));
  }
}
